import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M.633 1.01a.75.75 0 0 1 .684-.442h13.365a.75.75 0 0 1 .56 1.248l-5.156 5.8v4.393a.75.75 0 0 1-.22.53l-2.673 2.674a.75.75 0 0 1-1.28-.53V7.616l-5.156-5.8a.75.75 0 0 1-.124-.806Zm2.355 1.058 4.067 4.576c.23.26.358.594.358.941v5.286L8.586 11.7V7.585c0-.347.127-.682.358-.94l4.067-4.577H2.989Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n
];
function r(d, a) {
  return e(), t("svg", l, [...c]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
